import { UpdateWalletForm } from '../../components/forms/Forms';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { config } from '../../Constants';

const Wallets = () => {
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const [wallets, setWallets] = useState([]);
  const baseURL = config.baseURL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/admin-wallets`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setWallets(data);
      } catch (error) {}
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='content wallets-page'>
      <h1 className='title'>Wallets</h1>

      {wallets.map((wallet) => {
        return (
          <div className='block' key={wallet._id}>
            <div className='title-block'>
              <h2 className='title'>{wallet.walletName}</h2>
              <h4 className='sub-title'>Update Wallet Address</h4>
            </div>
            <hr />
            <UpdateWalletForm data={wallet} />
          </div>
        );
      })}
    </main>
  );
};

export default Wallets;
